import React from 'react';
import classnames from 'classnames';
import s from './EmptyBackground.scss';
export var EmptyBackground = function (_a) {
    var className = _a.className;
    return React.createElement("div", { className: classnames(s['root'], className) });
};
EmptyBackground.displayName = 'EmptyBackground';
export default EmptyBackground;
//# sourceMappingURL=EmptyBackground.js.map